import { ConsumerScanHistoryComponent, HelperWrapper, MainContainer } from 'src/components'
import { ETranslationNs } from 'src/types'

// Actually it is ConsumerRewardActivities

const ConsumerScanHistoryScreen = () => {
  return (
    <MainContainer
      headerTitle={
        <HelperWrapper t="consumer-scan-history-header-title" ns={ETranslationNs.Navbar} />
      }
      // withAccountIcon
      // withScanBtn
    >
      <ConsumerScanHistoryComponent />
    </MainContainer>
  )
}

export default ConsumerScanHistoryScreen
